<template>
  <div class="genre has-background-white-bis fixspace" :key="tag.slug">
    <section class="hero is-medium">
      <div class="hero-body">
        <div class="container is-max-desktop">
          <h1 class="title pb-5">
            <b-skeleton width="20%" size="is-large" :active="loadingTag"></b-skeleton>
            {{ tag.trans || tag.name }}
          </h1>
          <div class="columns is-vcentered">
            <div class="column is-one-quarter">
              <span class="has-text-weight-medium has-text-black has-text-weight-medium">
                {{ $t('general.genre') }}
              </span>
              <hr class="my-3" style="border-top:2px solid #000 !important; height:1px !important;">
              <b-dropdown
                :scrollable="true"
                :max-height="200"
                class="is-down" aria-role="list" style="z-index:2;">
                  <button class="button is-text px-0" style="text-decoration:none;"
                  slot="trigger"
                  >
                    <span class="has-text-weight-medium has-text-black">
                      {{ tag.trans || tag.name }}
                    </span>
                    <span class="icon is-medium is-right search-hide">
                      <i class="fas fa-chevron-down"></i>
                    </span>
                  </button>

                  <b-dropdown-item has-link aria-role="listitem"
                    v-for="tag in genre" :key="tag.slug">
                    <router-link :to="{ path: '/genre/' + tag.slug }">
                      {{ tag.trans || tag.name }}
                    </router-link>
                  </b-dropdown-item>
              </b-dropdown>
            </div>
            <div class="column is-one-fifth">
              <span class="has-text-black has-text-weight-medium">{{ $t('performs.works') }}</span>
              <hr class="my-3" style="border-top:2px solid #000 !important; height:1px !important;">
              <div class="py-2 has-text-weight-medium has-text-black">{{ total }}</div>
            </div>
            <div class="column is-one-fifth">
              <router-link to="/submit">
                <button class="button is-grey py-6 px-6 ml-5 is-hidden-touch"
                  style="z-index:1;">
                  <span class="has-text-weight-semibold">
                    {{ $t('general.submit') }}
                  </span>
                </button>
              </router-link>
              <router-link to="/submit">
                <button class="button is-grey is-fullwidth is-hidden-desktop"
                  style="z-index:1;">
                  <span class="has-text-weight-semibold">
                    {{ $t('general.submit') }}
                  </span>
                </button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="subpages-background">
        <div class="in">
          <div class="split">
            <span class="is-uppercase" style="opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);">
              {{ tag.slug}}
            </span>
          </div>
        </div>
      </div>
      <div class="has-text-centered">
        <b-button
          class="my-5 has-text-weight-semibold"
          :label="$t('general.share')"
          type="is-black"
          @click="shareModal" />
        <div>
          <i class="fas fa-chevron-down my-6"></i>
        </div>
      </div>
    </section>

    <section class="section">

      <div class="container">
        <div class="columns">
          <div class="column is-three-fifths is-offset-one-fifth">
            <div class="columns is-variable is-5 is-multiline">
              <div class="column is-half" v-for="item in list" :key="item.id">
                <router-link :to='"/video/" + item.id' :title="item.title">
                  <video-item
                    :channel-title="item.channel.title"
                    :youtube-id="item.provider_video_id"
                    :title="item.title" >
                  </video-item>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container has-text-centered" v-if="isEmpty">
        <h2 class="is-size-5-desktop is-size-6-mobile has-text-weight-semibold pb-5">
          {{ $t('general.stilllooking') }}
        </h2>
        <router-link to="/submit">
          <button class="button mx-1 px-5 py-5 my-5 is-black">
            <span class="has-text-weight-semibold">
              {{ $t('general.submitwork') }}
            </span>
          </button>
        </router-link>
        <div class="py-6">
          <img src="/assets/empty.png" :alt="$t('general.stilllooking')">
        </div>
      </div>

      <div class="container has-text-centered">
        <infinite-loading
          v-if="isFirstPageFinished"
          spinner="waveDots"
          @infinite="infiniteHandler">
          <div slot="no-more"></div>
          <div slot="no-results"></div>
        </infinite-loading>
      </div>
    </section>
  </div>
</template>

<script>
import ShareModal from 'components/ShareModal.vue';
import { getVideos, getTagBySlug, getTags } from '@/api/api';

export default {
  name: 'TagPage',

  metaInfo() {
    return {
      title: `${this.tag.trans || this.tag.name} - ${this.$t('title.genre')}`,
      meta: [
        { name: 'description', vmid: 'description', content: this.$t('about.abouthero1') },
        { property: 'og:title', vmid: 'og:title', content: `${this.tag.trans || this.tag.name} - ${this.$t('title.genre')}` },
        { property: 'og:image', vmid: 'og:image', content: `/assets/genre/${this.tag.slug}.jpg` },
        { property: 'og:description', vmid: 'og:description', content: this.$t('about.abouthero1') },
      ],
    };
  },

  data() {
    return {
      tag: {
        name: '',
        slug: '',
      },
      currentUrl: '',
      list: [],
      limit: 12,
      page: 1,
      total: 1,
      lastPage: 0,
      isEmpty: false,
      isFirstPageFinished: false,
      loading: true,
      loadingTag: true,
      keyboard: [],
      string: [],
      wind: [],
      percussion: [],
      genre: [],
    };
  },
  computed: {
  },

  created() {
    this.currentUrl = window.location.href;
    this.fetchData(this.$route.params.slug, true);
  },

  beforeRouteUpdate(to, from, next) {
    this.page = 1;
    this.lastPage = 0;
    this.isEmpty = false;
    this.isFirstPageFinished = false;
    this.fetchData(to.params.slug);
    next();
  },

  methods: {
    shareModal() {
      this.$FModal.show({
        component: ShareModal,
        overlayStyles: {
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
        },
      },
      {
        shareId: this.tag.slug,
        shareRoute: 'genre',
        shareTitle: `${this.title} - Musian`,
      });
    },

    setFallbackImageUrl(event) {
      const id = event.path[0].parentElement.getAttribute('vt-id');
      const image = event.path[0];

      if (image.naturalWidth === 120) {
        image.src = `https://i.ytimg.com/vi/${id}/mqdefault.jpg`;
      }
    },

    fetchData(slug, isFetchTags = false) {
      getTagBySlug(slug, { headers: { locale: this.$i18n.locale } })
        .then((result) => {
          const infoData = result.data.data;
          this.title = infoData.name;
          this.tag = result.data.data;

          this.loadingTag = false;
          this.$emit('forGtagStatus', `${this.tag.trans} - ${this.$t('title.genre')}`);
        }).catch((err) => {
          console.error(err);

          if (err.request.status === 404) {
            this.$router.push({ name: '404' });
          }
        });

      getVideos({ params: { tags: slug, limit: this.limit, page: this.page } })
        .then((result) => {
          const { data, total, last_page: lastPage } = result.data;
          this.total = total;
          this.list = data;
          this.lastPage = lastPage;

          if (data.length === 0) {
            this.isEmpty = true;
          } else {
            this.page += 1;
          }

          this.isFirstPageFinished = true;
        }).catch((err) => { console.error(err); });

      if (isFetchTags) {
        getTags(null, { headers: { locale: this.$i18n.locale } })
          .then((result) => {
            const { data } = result.data;

            this.keyboard = data.filter((item) => item.type === 'keyboard');
            this.string = data.filter((item) => item.type === 'string');
            this.wind = data.filter((item) => item.type === 'wind');
            this.percussion = data.filter((item) => item.type === 'percussion');
            this.genre = data.filter((item) => item.type === 'genre');

            this.loading = false;
          })
          .catch((err) => { console.error(err); });
      }
    },

    infiniteHandler($state) {
      if (this.page + 1 > this.lastPage) {
        $state.complete();
        return;
      }

      getVideos({ params: { tags: this.$route.params.slug, limit: this.limit, page: this.page } })
        .then((result) => {
          const { data } = result.data;

          if (data.length > 0) {
            this.page += 1;
            this.list.push(...data);
            $state.loaded();
          } else {
            $state.complete();
          }
        }).catch((err) => { console.error(err); });
    },
  },
};
</script>

<style lang="scss" scoped>
.subpages-background {
  z-index: 0;
}
.subpages-background {
  position: fixed;
  height: 100%;
  top: 0;
  left: 0;
  width: 100%;
  white-space: nowrap;
  transition: all 0.5s;
  overflow: hidden;
}
.subpages-background .in {
  font-size: 0;
}
.in {
  width: 100%;
  height: 100%;
  position: relative;
}
.subpages-background .split {
  display: inline-block;
  position: absolute;
  height: 545px;
  top: 50%;
  left: 0;
  width: 100%;
  font-weight: bold;
  margin-top: -372.5px;
  text-align: right;
}
.subpages-background .split span {
  color: #f9f9f9;
}
.subpages-background .split span {
  display: inline-block;
  vertical-align: top;
  font-size: 20rem;
  color: rgba(0, 0, 0, 0.015);
}
</style>
